const common = {
  'common.loading': 'Loading...',
  'common.error': 'An error occurred',
  'common.success': 'Success!',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.submit': 'Submit',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.add': 'Add',
  'common.remove': 'Remove',
  'common.continue': 'Continue',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.sort': 'Sort',
  'common.noResults': 'Page not found',
  'common.selectOne': 'Select one',
  'common.required': 'Required',
  'common.optional': 'Optional',
  'common.learnMore': 'Learn More',
  'common.getStarted': 'Get Started',
  'common.signUp': 'Sign Up',
  'common.signIn': 'Sign In',
  'common.dark': 'Dark',
  'common.light': 'Light',
  'common.system': 'System',
  'common.followTheme': 'Follow system theme',
  'common.language': 'Language',
  'common.viewMore': 'View More',
  'common.viewLess': 'View Less',
  'common.home': 'Home',
  'common.terms': 'Terms of Service',
  'common.privacy': 'Privacy Policy',
  'common.cookies': 'Cookie Policy',
  'common.contact': 'Contact Us',
  'common.contactMe': 'Contact Me',
  'common.profile': 'Profile',
  'common.settings': 'Settings',
  'common.account': 'Account',
  'common.dashboard': 'Dashboard',
  'common.theme.light': 'Light Theme',
  'common.theme.dark': 'Dark Theme',
  'Member Since': 'Member Since',
  'profileNotFound': 'Profile not found',
  'common.documentation': 'API Documentation',
  
  // Navigation items
  'nav.home': 'Home',
  'nav.news': 'News',
  'nav.join': 'Join The Club',
  'nav.tutorials': 'Tutorials',
  'nav.strategies': 'Strategies',
  'nav.radex': 'Radex Markets',
  
  // News page translations
  'news.title': 'Latest News',
  'news.description': 'Stay updated with our latest articles and announcements',
  'news.filterByTag': 'Filter by tag',
  'news.allPosts': 'All Posts',
  'news.noPostsFound': 'No posts found',
  'news.viewAllPosts': 'View all posts',
  'news.backToNews': 'Back to News',
  'news.relatedPosts': 'Related Posts',
  'news.sharePost': 'Share this post',
  'news.postNotFound': 'Post not found',
  'news.pagination.previous': 'Previous',
  'news.pagination.next': 'Next',
  
  // Social media links
  'social.instagram': 'https://www.instagram.com/theclub.finance/',
  'social.tiktok': 'https://www.tiktok.com/@the.club.fund',
  'social.youtube': 'https://www.youtube.com/@TheClub.finance',
  'social.facebook': 'https://www.facebook.com/profile.php?id=61576120443819',
  'social.telegram': 'https://t.me/theclubfund',
  
  // Footer translations
  'footer.company.description': 'The Club offers innovative financial products and services designed to help you grow your wealth and achieve financial freedom.',
  'footer.theclub': 'The Club',
  'footer.conditions': 'Terms and conditions',
  'footer.customersupport': 'Customer Support',
  'footer.contactuswhatsapp': 'WhatsApp',
  'footer.radex': 'Radex Markets',
  'footer.rights': 'All rights reserved.',
  'footer.terms': 'Terms',
  'footer.privacy': 'Privacy',
  'footer.cookies': 'Cookies',
  'footer.contactUs': 'Contact Us',
  'footer.contactMe': 'Contact Me',
  
  // Radex Markets translations
  'radex.hero.title': 'The Club & Radex Markets Partnership',
  'radex.hero.subtitle': 'Unleash exceptional trading opportunities through our strategic partnership',
  'radex.hero.learnMore': 'Learn More',
  'radex.hero.visitWebsite': 'Visit Website',
  'radex.hero.partnership': 'Exclusive Investment Opportunities',
  'radex.hero.benefit1': 'Licensed & Regulated Broker',
  'radex.hero.benefit2': 'Cutting-edge Trading Technology',
  'radex.hero.benefit3': 'Advanced Security Protocols',
  'radex.hero.benefit4': 'Exclusive Club Member Benefits',
  
  'radex.about.title': 'About Radex Markets',
  'radex.about.subtitle': 'A regulated broker committed to security, transparency, and cutting-edge trading technology',
  'radex.about.establishmentTitle': 'Established Presence',
  'radex.about.establishmentText': 'RADEX MARKETS was established in 2019 and is headquartered in the Republic of Seychelles. Operating under the trading name of GO Markets International Ltd, a company incorporated in the Republic of Seychelles with registration number 8425985-1.',
  'radex.about.regulationTitle': 'Licensed & Regulated',
  'radex.about.regulationText': 'The firm is licensed and regulated by the Seychelles Financial Services Authority (FSA) under Securities Dealer License Number SD043, ensuring a secure and compliant trading environment.',
  'radex.about.technologyTitle': 'Advanced Technology',
  'radex.about.technologyText': 'Radex Markets offers cutting-edge technology and a competitive trading environment designed to meet the needs of modern traders, with reliable execution and professional tools.',
  'radex.about.transparencyTitle': 'Transparency & Trust',
  'radex.about.transparencyText': 'Transparency is a core value at Radex, demonstrated through clear, honest, and multilingual communication. Renowned for its integrity, Radex Markets stands out as a secure and trustworthy platform for traders seeking reliability.',
  
  'radex.features.title': 'Why did we choose Radex Markets?',
  'radex.features.subtitle': 'Experience the advantages of trading with a broker committed to excellence',
  'radex.features.security': 'Client Protection',
  'radex.features.securityText': 'Robust security protocols to safeguard client funds and personal data, ensuring a safe trading environment.',
  'radex.features.technology': 'Cutting-Edge Platform',
  'radex.features.technologyText': 'Advanced trading technology with reliable execution and professional tools for traders of all levels.',
  'radex.features.transparency': 'Full Transparency',
  'radex.features.transparencyText': 'Clear, honest communication and dependable trade execution, maintaining the highest standards of transparency.',
  'radex.features.global': 'Global Access',
  'radex.features.globalText': 'Multilingual support and services catering to traders from various regions and backgrounds.',
  
  'radex.partnership.title': 'The Club & Radex Markets Partnership',
  'radex.partnership.description': 'Our strategic partnership with Radex Markets enables us to offer unique investment opportunities to our club members, combining our expertise with a regulated and trusted broker.',
  'radex.partnership.details': 'Through this collaboration, members of The Club gain access to exclusive trading conditions, enhanced account management, and specialized support from both organizations. The Radex Markets and The Club partnership is built on shared values of transparency, security, and delivering exceptional value to our community.',
  'radex.partnership.contactUs': 'Contact for Details',
  'radex.partnership.visitRadex': 'Visit Radex Markets',
  'radex.partnership.benefitsTitle': 'Partnership Benefits',
  'radex.partnership.benefit1Title': 'Enhanced Security',
  'radex.partnership.benefit1Text': 'Trade with confidence knowing your funds are protected by Radex Markets\' robust security protocols.',
  'radex.partnership.benefit2Title': 'Exclusive Products',
  'radex.partnership.benefit2Text': 'Access specialized investment products and trading conditions available only to Club members.',
  'radex.partnership.benefit3Title': 'Professional Support',
  'radex.partnership.benefit3Text': 'Receive dedicated assistance from both The Club and Radex Markets teams for an enhanced trading experience.',
    
  // Documentation translations
  'docs.title': 'API Documentation',
  'docs.introduction': 'Introduction',
  'docs.introDescription': 'This application uses GraphQL as a flexible data access layer, powered by the pg_graphql extension in Supabase.',
  'docs.benefits': 'Benefits of this approach include:',
  'docs.benefitDecoupling': 'Decoupling the frontend from direct database access',
  'docs.benefitTypeSafety': 'Strong type safety throughout the application',
  'docs.benefitFlexibility': 'Flexibility to switch backend implementations with minimal changes',
  'docs.architecture': 'Architecture Overview',
  'docs.architectureDescription': 'The application uses a layered architecture that separates concerns and provides flexibility:',
  'docs.serviceLayer': 'Service Abstraction Layer',
  'docs.serviceLayerDescription': 'The service layer provides a consistent interface regardless of the underlying implementation, allowing the application to switch between direct Supabase calls and GraphQL queries without changing the application code.',
  'docs.schema': 'GraphQL Schema',
  'docs.schemaDescription': 'The GraphQL schema is automatically generated from the database structure by pg_graphql, with some additional custom resolvers for specific needs:',
  'docs.implementationGuide': 'Implementation Guide',
  'docs.frontendImplementation': 'Frontend Implementation',
  'docs.frontendImplementationDescription': 'To interact with the GraphQL API from the frontend, use Apollo Client:',
  'docs.serviceFactory': 'Service Factory',
  'docs.serviceFactoryDescription': 'The service factory pattern allows easy switching between different service implementations:',
  'docs.switchingBackends': 'Switching Backends',
  'docs.switchingBackendsDescription': 'To switch between different backend implementations, call the setServiceImplementation function:',
  'docs.backendImplementation': 'Backend Implementation',
  'docs.backendImplementationDescription': 'The backend uses Supabase with the pg_graphql extension to provide a GraphQL API:',
  'docs.pgGraphql': 'pg_graphql Extension',
  'docs.pgGraphqlDescription': 'The pg_graphql extension automatically generates a GraphQL API from your database schema:',
  'docs.alternativeBackends': 'Alternative Backends',
  'docs.alternativeBackendsDescription': 'To implement alternative backends, create new service implementations that conform to the service interfaces defined in the service factory.',

  // Error translations
  'error.defaultTitle': 'An error has occurred',
  'error.defaultMessage': ' ', 
  'error.profileInvalidTitle': 'An error has occurred',
  'error.profileInvalidMessage': 'The user profile is invalid',
  'error.goHome': 'Go to Home',
  'error.contactSupport': 'Contact Support',
};

const calendar = {
  'calendar.january': 'January',
  'calendar.february': 'February',
  'calendar.march': 'March',
  'calendar.april': 'April',
  'calendar.may': 'May',
  'calendar.june': 'June',
  'calendar.july': 'July',
  'calendar.august': 'August',
  'calendar.september': 'September',
  'calendar.october': 'October',
  'calendar.november': 'November',
  'calendar.december': 'December',
  'calendar.months.january': 'Jan',
  'calendar.months.february': 'Feb',
  'calendar.months.march': 'Mar',
  'calendar.months.april': 'Apr',
  'calendar.months.may': 'May',
  'calendar.months.june': 'Jun',
  'calendar.months.july': 'Jul',
  'calendar.months.august': 'Aug',
  'calendar.months.september': 'Sep',
  'calendar.months.october': 'Oct',
  'calendar.months.november': 'Nov',
  'calendar.months.december': 'Dec',
  'calendar.weekdays.monday': 'Mo',
  'calendar.weekdays.tuesday': 'Tu',
  'calendar.weekdays.wednesday': 'We',
  'calendar.weekdays.thursday': 'Th',
  'calendar.weekdays.friday': 'Fr',
  'calendar.weekdays.saturday': 'Sa',
  'calendar.weekdays.sunday': 'Su',
};

export default {
  ...common,
  ...calendar,
};
